<template>
  <v-app id="inspire">
    <Header v-model="expandOnHover"></Header>
    <v-content :style="styleMain">
      <v-container fluid class="page-wrapper">
        <router-view />
        <v-btn bottom color="primary" dark fab fixed right @click.stop="setCustomizerDrawer(!Customizer_drawer)">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-container>
    </v-content>
    <Sidebar :expand-on-hover.sync="expandOnHover"></Sidebar>

    <Customizer v-model="expandOnHover"></Customizer>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import Footer from './footer/Footer';
import Customizer from './customizer/Customizer';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Layout',

  components: {
    Header,
    Sidebar,
    Footer,
    Customizer
  },

  props: {
    source: String
  },
  data: () => ({
    expandOnHover: false,
    styleMain: ''
  }),
  computed: {
    ...mapState(['Customizer_drawer'])
  },
  watch: {
    expandOnHover(val) {
      this.updateMainStyle(val);
      this.setSidebarExpand(!val);
    },
    '$vuetify.breakpoint.smAndDown'() {
      this.updateMainStyle(this.expandOnHover);
    }
  },
  mounted() {
    this.updateMainStyle(this.expandOnHover);
  },
  methods: {
    ...mapMutations({
      setCustomizerDrawer: 'SET_CUSTOMIZER_DRAWER'
    }),
    ...mapMutations({
      setSidebarExpand: 'SET_SIDEBAR_EXPAND'
    }),
    updateMainStyle(val) {
      if (this.$store.state.Sidebar_drawer) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.styleMain = 'padding: 64px 0px 60px 0px;';
          return;
        }
        if (!val) {
          this.styleMain = 'padding: 64px 0px 60px 300px;';
        } else {
          this.styleMain = 'padding: 64px 0px 60px 70px;';
        }
      } else {
        this.styleMain = '';
      }
    }
  }
};
</script>

<style></style>
